<template>
        <div class="row justify-content-center">
            <div class="col-lg-5 col-md-7">
                <div class="card bg-secondary shadow border-0">
                    <div class="card-body px-lg-5 py-lg-5">
                        <div class="text-center text-muted mb-4">
                            <small>Bitte geben Sie den/die Benutzername/Email hier ein.</small>
                            <base-alert v-if="alert.message" :type="alert.type">{{alert.message}}</base-alert>
                        </div>
                        <form @submit="handleSubmit">
                            <base-input class="input-group-alternative mb-3"
                                        placeholder="Benutzername/Email"
                                        addon-left-icon="ni ni-email-83"
                                        v-model="model.email"
                            :disabled="isLoading">
                            </base-input>

                            <div class="text-center">
                                <button class="btn my-4 btn-primary" :disabled="isLoading" type="submit">Neues Passwort anfordern</button>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col text-right">
                      <router-link to="/" class="btn btn-info btn-block">zurück zum Login</router-link>
                      <a href="https://config.socialguard.app/#/pid/3x90" class="btn btn-success btn-block" target="_blank">Geschäftskunde werden</a>
                    </div>
                </div>
            </div>
        </div>
</template>
<script>


  export default {
    name: 'ForgotPassword',
    data() {
      return {
          isLoading: false,
        model: {
          email: '',
          submitted: false
        }
      }
    },
      computed: {
          alert () {
              return this.$store.state.alert
          }
      },
      created () {

      },
      methods: {
          handleSubmit (e) {
              e.preventDefault();
              return new Promise(() => {
                  this.submitted = true;
                  let senddata = this.model;
                  this.isLoading = true;
                  const requestOptions = {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify(senddata)
                  };

                  fetch(process.env.VUE_APP_API_SERVER + `/forgotpw`, requestOptions)
                      .then(this.handleResponse)
                      .then(response => { this.$store.dispatch('alert/success',response); this.isLoading = false;},
                          error => { this.$store.dispatch('alert/error',error); this.isLoading = false;});
              });

          }
      }
  }
</script>
<style>
</style>
